module.exports = __webpack_public_path__ + "static/media/catering-banner-760.57374deb.png";